import { DataService } from "./DataService.js";

export class ChunkDataService extends DataService {
    getMergedChunkForIDList(idList) {
        
    }

    isWithCache() {
        return false;
    }
}